/** Chrome around the QR image in `QrExpandedDialog` + `QRCodeElement` wrapper. */
const OVERLAY_AND_CONTENT_PAD = 72
const QR_ELEMENT_CHROME = 44
const VERTICAL_CHROME = 200
const MIN_QR_SIZE = 200
const MAX_QR_SIZE = 360

export type ScanQrViewport = {
  width: number
  height: number
}

const defaultViewport = (): ScanQrViewport =>
  typeof window === 'undefined' ? { width: 390, height: 844 } : { width: window.innerWidth, height: window.innerHeight }

/** Largest QR image that still fits a full-screen scan overlay. */
export const getScanQrSize = (viewport: ScanQrViewport = defaultViewport()): number => {
  const byWidth = viewport.width - OVERLAY_AND_CONTENT_PAD - QR_ELEMENT_CHROME
  const byHeight = viewport.height - VERTICAL_CHROME
  return Math.round(Math.max(MIN_QR_SIZE, Math.min(byWidth, byHeight, MAX_QR_SIZE)))
}
